<ra-app-header></ra-app-header>

<div class="content">
	<!--<div style="background: yellow; height: 50px; width: 50px"></div>-->
	<ra-nav></ra-nav>
	<div class="page-content">
		<router-outlet></router-outlet>
	</div>
</div>
